<template>
  <div
    class="flex h-full items-center ripple w-full pb-5"
    @click="
      $bus.emit($constants.EVENTS.TRANSACTIONS.DETAILS_REQUESTED, $attrs.item)
    "
  >
    <div class="flex gap-2 items-center w-full">
      <div class="w-18 h-18 rounded-full bg-white p-2 shimmerTarget relative">
        <ImgComponent
          :src="$attrs.item?.logo"
          alt=""
          class="w-full h-full rounded-full"
        />
        <div
          class="w-7 h-7 absolute bottom-0 right-0 rounded-full p-1 shimmerTarget"
          :class="{
            'bg-[#27BE43]': $attrs.item?.operation == 'fund',
            'bg-[#FF4F6C]': $attrs.item?.operation == 'withdraw'
          }"
        >
          <ColorImg
            src="/images/icons/arrow-up.svg"
            alt=""
            :class="{
              'rotate-30': $attrs.item?.operation == 'fund',
              'rotate-210': $attrs.item?.operation == 'withdraw'
            }"
            class="w-full h-full rounded-full bg-white"
          />
        </div>
      </div>
      <div class="flex flex-col items-start">
        <div class="font-semibold text-lg shimmerTarget min-w-24 title-color">
          {{ $attrs.item?.operationNameDisplay }} &nbsp;
        </div>
        <div class="description-color shimmerTarget min-w-32 mt-0.5">
          {{ $attrs.item?.startDate }} &nbsp;
        </div>
      </div>
      <div class="ml-auto text-end items-end flex flex-col font-bold">
        <div
          class="min-w-16 shimmerTarget text-lg"
          :class="{
            'text-[#27BE43]': $attrs.item?.operation == 'fund',
            'text-[#FF4F6C]': $attrs.item?.operation == 'withdraw'
          }"
        >
          {{
            $attrs.item?.operation == 'fund'
              ? '+'
              : $attrs.item?.operation == 'withdraw'
              ? '-'
              : ''
          }}
          {{ $attrs.item?.amountToReceive }}
          CFA &nbsp;
        </div>
        <div class="mt-0.5 w-[1lh] h-lh shimmerTarget mr-2 p-1">
          <ColorImg
            src="/images/icons/right-arrow.svg"
            alt=""
            class="w-full h-full rounded-full bg-gray-300"
          />
        </div>
      </div>
    </div>
  </div>
</template>
